import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { cn } from "@/lib/utils";

export default function FavoriteButton({ wineId, size = 18, className }) {
  const { isFavorite, toggle } = useFavorites();
  const active = isFavorite(wineId);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(wineId);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={`favorite-btn-${wineId}`}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={active}
      className={cn(
        "inline-flex items-center justify-center w-8 h-8 rounded-full border transition-all duration-200",
        active
          ? "bg-merlot/20 border-merlot/50 text-merlot-light hover:bg-merlot/30"
          : "bg-transparent border-white/10 text-white/40 hover:text-merlot-light hover:border-merlot/40",
        className
      )}
    >
      <Heart className={cn("transition-transform", active && "fill-current scale-110")} style={{ width: size, height: size }} />
    </button>
  );
}
